m = require 'mithril'

page = (args...) ->
	m '.page', args...

icon = (content, classname = 'icon') ->
	m "span.#{classname}[aria-hidden=true][data-icon=#{content}]"

icons = {
	'home': "\ue900"
	'spades': "\ue901"
	'clubs': "\ue902"
	'diamonds': "\ue903"
	'pencil': "\ue904"
	'floppydisk': "\ue905"
	'userplus': "\ue906"
	'userminus': "\ue907"
	'plus': "\ue908"
	'bin': "\ue909"
}

list = (items, itemMapper, noItems) ->
	m 'ul',
		if items.length > 0
		then items.map (item, ix) ->
			m 'li', itemMapper item, ix
		else m 'li', noItems

table = (headerRows, bodyRows) ->
	m 'table', [
		m 'thead', headerRows
		m 'tbody', bodyRows
	]

pageHeading = (contents) ->
	m 'h1.heading', contents

errors = (errors) ->
	if errors.length > 0
		m 'div',
			m 'p', m 'b', 'Validation errors'
			m 'ul.errors', errors.map (e) ->
				m 'li', e

module.exports = {
	page
	list
	table
	pageHeading
	errors
	icon
	icons
}